export const CERTIFICATION_COOKIE = 'CERTIFICATION_COOKIE'
export const HIDE_CERTIFICATION_MODAL = 'HIDE_CERTIFICATION_MODAL'
export const LAST_SYNC_LOCAL_USER = 'last_sync_local_user'
